import type { Client } from "../client";
import type { MaintenanceConfigurationResource } from "../resources";
import { ConfigurationRepository } from "./configurationRepository";

export class MaintenanceConfigurationRepository extends ConfigurationRepository<MaintenanceConfigurationResource> {
    constructor(client: Client) {
        super("MaintenanceConfiguration", client);
    }
}
